export const nlpProviders = {
  dialogFlowV2: 'dialogFlowV2',
}
